import React, { createContext, useState } from 'react';

export const EmailContext = createContext();

export const EmailProvider = ({ children }) => {
  const [newEmail, setNewEmail] = useState('');
  return <EmailContext.Provider value={[newEmail, setNewEmail]}>{children}</EmailContext.Provider>;
};
